export default "__VITE_ASSET__BWIjrZZP__"